<template>
  <div class="ai-report-payment" :class="{segment: reportType === 'segment'}">
    <span v-if="reportType !== 'mashup'" class="close-btn" @click="$emit('close')">
      <i class="icon icon--close-btn size-16"></i>
    </span>
    <div class="ai-payments-header" :class="{segment: reportType === 'segment'}">{{ $t(`aiReport.${reportType}.title`) }}</div>
    <div ref="scrollArea" class="ai-payments-contents" :class="{segment: reportType === 'segment'}">
      <div class="payments-select-wrapper">
        <div v-if="currentStep === 1" class="payment-report-wrapper">
          <div v-if="reportType !== 'mashup'" class="report-name">
            <div class="label">{{ $t(`aiReport.payment.name`) }}</div>
            <div class="input-wrap" :class="{error: errMessage}">
              <input type="text" v-model="editableTitle" :placeholder="$t(`aiReport.payment.placeholder`)" @input="checkMaxLength" />
              <template v-if="errMessage">
                <i  class="icon icon--triangle-alert" ></i>
                <div class="input-error-pop">
                  <div class="error-text brand-mark" v-html="errMessage"></div>
                </div>
              </template>
              <i v-else-if="editableTitle !== ''" class="icon icon--close14" @click="editableTitle = ''" />
            </div>
          </div>
          <div class="report-segment-info">
            <template v-if="isTimeMachine">
              <div class="segment-badge">TimeMachine</div>
              <div class="segment-notice">
                <p class="segment-notice__text" v-html="$t('aiReport.timeMachineNotice')"></p>
              </div>
            </template>
            <div class="segment-detail-list">
              <template v-for="seg in segmentColumn">
                <div class="segment-info-item"  :key="seg.name" :class="seg.name">
                  <template>
                    <div class="label-text" :class="{'compare': seg.isCompare }">{{ $t(`mine.report.detail.${seg.name}`) }}</div>
                    <div class="value-text" :class="{ 'upper-first': seg.name === 'device' || seg.name === 'compare-device', 'compare': seg.isCompare }">
                      <template v-if="seg.name === 'url'">
                        [{{ selectedReport.matchType }}] {{selectedReport.url}} {{ selectedReport.matchString ? `+ ${selectedReport.matchString}` : ''}}
                      </template>
                      <template v-else-if="seg.name === 'period'">
                        <div v-if="isTimeMachine" class="date-range base">{{ formatDateTime(selectedReport.startDate) }}~ {{ formatDateTime(selectedReport.endDate) }}</div>
                        <div v-else class="date-range base">{{ selectedReport.startDate }} ~ {{ selectedReport.endDate }} {{selectedReport.endTime ? selectedReport.endTime : ''}}</div>
                      </template>
                      <template v-else-if="seg.name === 'utm'">
                        <div v-if="!selectedReport.utm" class="colum-text">{{ $t('common.all') }}</div>
                        <div v-else class="marketing-info-btn" :class="{ show: showMarketing }" @click="showMarketing = !showMarketing">
                          UTM Parameter
                          <i class="icon icon--arrow-up-black size-14" />
                        </div>
                        <template v-if="showMarketing">
                          <template v-if="marketing.type === 'utm'">
                            <div class="contents">
                              <div class="marketing-data-list">
                                <div class="marketing-data-item" v-for="(value, name) in marketing.data" :key="name">
                                  <template v-if="value">
                                    <span class="label">{{ name }}:</span>
                                    <span class="value">
                                      {{ formatValues(value) }}
                                    </span>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <template v-else-if="seg.name === 'device'">
                        {{ selectedReport[seg.name] ? selectedReport[seg.name] : $t('common.all') }}
                      </template>
                      <template v-else-if="seg.name === 'existing'">
                        {{ selectedReport[seg.name] ? $t('common.revisit') : selectedReport[seg.name] === false ? $t('common.new') : $t('common.all') }}
                      </template>
                      <template v-else-if="seg.name === 'hour'">
                        {{ selectedReport[seg.name] && selectedReport[seg.name] !== 'all' ? `${selectedReport[seg.name]}:00 ~ ${selectedReport[seg.name]}:59` : $t('common.all') }}
                      </template>
                      <template v-else-if="seg.name === 'freq'">
                        {{ formatFreqRange(selectedReport[seg.name], selectedReport['freq_option']) }}
                      </template>
                      <template v-else>
                        {{ selectedReport[seg.name] && selectedReport[seg.name] !== 'all' ? selectedReport[seg.name] : $t('common.all') }}
                      </template>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div v-if="reportType !== 'mashup'" class="payment-options-list">
            <div class="select-payment-option">
              <div class="title-label" v-html="$t('aiReport.payment.paymentLang')"></div>
              <div class="select-option-wrapper">
                <div v-for="item in localeList" :key="item.code" class="payment-type" :class="[{selected: item.code === reportLang}]"  @click="reportLang = item.code">
                  <div class="payment-title" >
                    <span class="check-selected"></span>
                    <div  class="lang" >
                      <i class="icon icon--flag ko" :class="item.code"></i>
                      <span class="lang-text">{{ item.code}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentStep === 2" class="payments-method-wrapper">
          <div class="payment-type" v-for="payment in paymentType" :key="payment.type"
            :class="[
              {selected: selectedType && payment.type === selectedType.type},
              {disabled: payment.disabled}
            ]">
            <div class="payment-title" @click="selectedType = payment">
              <span class="check-selected"></span>
              <div class="payment-name">{{ $t(`aiReport.payment.paymentType.${payment.type}`) }}</div>
            </div>
            <div class="payment-body">
              <template v-if="payment.type === 'jam'">
                <template v-if="remainJam > 0">
                  <div class="detail-info-wrapper jam">
                    <div class="detail-info-item has-jam">
                      <div class="title">{{ $t('common.holding') }}</div>
                      <div class="value">{{ remainJam | thousand }}</div>
                    </div>
                    <div class="detail-info-item use-jam">
                      <div class="title">{{ $t('common.spending') }}</div>
                      <div class="value">- {{ useJam | thousand }}</div>
                    </div>
                    <div class="detail-info-item leftover-jam">
                      <div class="title">{{ $t('common.remaining') }}</div>
                      <div class="value" v-if="leftoverJam >= 0">{{ leftoverJam | thousand }}</div>
                      <div class="error-msg" v-else>{{  $t('common.jamCharging') }}</div>
                    </div>
                  </div>
                  <div class="changing-jam-btn">
                    <button class="btf-button icon outline" @click="$emit('onChargeJam', remainJam)">
                      <i class="icon icon--plus"></i>
                      {{ $t('common.chargeJam') }}
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div class="detail-info-wrapper no-jam">
                    <div class="no-jam-contents">
                      <div class="text" v-html="$t('common.noJam')"></div>
                      <div class="changing-jam-btn">
                        <button class="btf-button icon outline" @click="$emit('onChargeJam', remainJam)">
                          <i class="icon icon--plus"></i>
                          {{ $t('common.chargeJam') }}
                        </button>
                  </div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <!-- <div v-if="payment.type === 'billing'" class="detail-description">뷰저블 Billing에 등록된 카드로 아래 금액이 자동 결제됩니다.</div> -->
                <div class="detail-info-wrapper ba-credit">
                  <div class="title">{{ $t('common.totalKRW') }}</div>
                  <div class="value price">₩ {{ price | thousand }} <span>({{ $t('payment.noVat2') }})</span></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="setNotification" class="ai-payments-notice">
        <ul class="notice-list">
          <li class="notice-item" v-if="reportType === 'mashup'" v-html="$t('aiReport.payment.mashupNotice')"></li>
          <li class="notice-item" v-else v-html="$t('aiReport.payment.paymentNotice1')"></li>
          <li class="notice-item" v-html="$t('aiReport.payment.paymentNotice2')"></li>
          <li class="notice-item" v-if="reportType === 'indepth'"  v-html="$t('aiReport.payment.indepth.paymentNotice')"></li>
        </ul>
      </div>
    </div>
    <div class="ai-payments-footer" :class="[{segment: reportType === 'segment'}, {'has-scroll': hasScroll}]">
      <template v-if="currentStep > 0" >
        <div v-if="setAgreement" class="ai-payments-check-confirm">
          <ui-checkbox :value="checkConfirm" @input="onChangeCheckboxValue" :disabled="disableAgreement">
            {{ $t('aiReport.paymentConfirm')}}
          </ui-checkbox>
        </div>
        <div class="payment-button-wrapper">
          <div v-if="currentStep === 2" class="go-back" @click="currentStep = currentStep - 1">
            <i class="icon icon--inflow__back"></i>
            <div class="label">{{ $t('common.prev') }}</div>
          </div>
          <template v-if="reportType !== 'mashup' && currentStep === 1 && !useVoucher">
            <!-- <button class="btf-button outline" @click="$emit('close')">{{ $t('common.cancel') }}</button> -->
            <button class="btf-button outline icon primary" :disabled="editableTitle === '' || errMessage !== ''" @click="nextAndDupCheck">
              {{ $t('common.next') }}
              <i class="icon icon--arrow-right-red"></i>
            </button>
          </template>
          <template v-if="reportType === 'mashup'">
            <button class="btf-button outline" @click="$emit('close')">{{ $t('common.cancel') }}</button>
            <button class="btf-button primary" @click="requestPayment">{{ $t('common.confirm') }}</button>
          </template>
          <template v-else-if="currentStep === 2">
            <!-- <button class="btf-button outline" @click="$emit('close')">{{ $t('common.cancel') }}</button> -->
            <button class="btf-button primary" :class="{disabled: !checkConfirm || disableAgreement}" @click="requestPayment">{{ $t('common.confirm') }}</button>
          </template>
          <template v-else-if="useVoucher">
            <!-- <button class="btf-button outline" @click="$emit('close')">{{ $t('common.cancel') }}</button> -->
            <button class="btf-button primary" :class="{disabled: !checkConfirm || disableAgreement}" @click="reportUseVoucher">{{ $t('common.confirm') }}</button>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRemainJam } from '@/api/jam'
import UiCheckbox from '@/components/ui/UiCheckbox.vue'
import { format, parse } from 'date-fns'

import { getSegmentOptions } from '@/api/ai'
import { getSegmentMetaTitle } from '@/data/ai-segment-meta'
import { FREQUENCY_PV_RANGE, FREQUENCY_SESSION_RANGE, LOCALE_LIST, REPORT_MORE_DATA } from '@/libs/constants'

const PAYMENT_TYPE = [
  { type: 'jam', name: 'JAM 결제', disabled: false }
]

export default {
  name: 'AiReportPayment',
  components: { UiCheckbox },
  props: {
    reportType: {
      type: String,
      default: null // prefix, compare, mashup, segment
    },
    reportName: {
      type: String
    },
    reportInfo: {
      type: Object,
      default: null
    },
    planInfo: {
      type: Object,
      default: null
    },
    compareRange: {
      type: Object,
      default: null
    },
    segmentMetaList: {
      type: Array,
      default: null
    },
    setList: {
      type: Array,
      default: null
    },
    reportMashup: {
      type: Array,
      default: null
    },
    compareTarget: {
      type: Object,
      default: null
    },
    apiParamsData: {
      type: Object,
      default: null
    },
    columnData: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      isReady: false,
      remainJam: 0,
      paymentType: PAYMENT_TYPE,
      selectedType: PAYMENT_TYPE[0],
      selectedMeta: null,
      checkConfirm: false,
      editableTitle: '',
      segmentColumn: REPORT_MORE_DATA.slice(),
      selectedReport: {},
      segmentType: '',
      segmentInfo: {},
      currentStep: 1,
      useVoucher: false,
      price: 0,
      useJam: 0,
      compareKey: '',
      errMessage: '',
      showMarketing: false,
      marketing: {},
      aiReportCredit: null,
      localeList: LOCALE_LIST,
      reportLang: this.$i18n.locale,
      hasScroll: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'applyBasketCount',
      'isDemo',
      'cxReportId'
    ]),
    isTimeMachine () {
      return this.apiParamsData && this.apiParamsData.event === 'timemachine'
    },
    leftoverJam () {
      return (this.remainJam - this.useJam)
    },
    setNotification () {
      return this.reportType === 'mashup' || (this.currentStep === 1 && this.useVoucher) || this.currentStep === 2
    },
    setAgreement () {
      return this.reportType !== 'mashup' && (this.useVoucher || this.currentStep === 2)
    },
    reportVoucher () {
      return this.aiReportCredit && this.aiReportCredit.remain > 0
    },
    disableAgreement () {
      return this.useVoucher ? !this.reportVoucher : this.selectedType.type === 'jam' ? this.leftoverJam < 0 : false
    }
  },
  watch: {
    useVoucher () {
      this.checkConfirm = false
    },
    currentStep (value) {
      if (value === 1) {
        this.errMessage = ''
      }
      const scrollArea = this.$refs.scrollArea
      if (scrollArea) {
        this.checkScroll()
        scrollArea.scrollTop = 0
      }
    },
    apiParamsData (value) {
      this.setReportInfo()
    }
  },
  created () {
    if (this.isDemo) {
      PAYMENT_TYPE.forEach(payment => {
        if (payment.type === 'justCard') {
          payment.disabled = true
        }
      })
    }

    if (this.planInfo) {
      this.useJam = this.isTimeMachine ? 100 : this.planInfo.jamPrice
    }

    this.getJamInfo()
  },
  mounted () {
    this.editableTitle = this.reportName

    if (this.columnData) {
      this.segmentColumn = this.columnData.slice()
    } else {
      const removeKeys = ['text']
      this.segmentColumn = this.segmentColumn.filter(col => !removeKeys.includes(col.name))
    }

    this.setReportInfo()
    if (this.$refs.scrollArea) {
      this.$refs.scrollArea.addEventListener('resize', this.checkScroll)
    }
  },
  beforeDestroy () {
    this.selectedReport = {}
    this.marketing = {}

    this.$refs.scrollArea.removeEventListener('resize', this.checkScroll)
  },
  methods: {
    formatDateTime (dateStr) {
      if (!dateStr) return ''
      return dateStr.replace('T', ' ').slice(0, 16)
    },
    parseFreqArr (arr) {
      return arr.flatMap(item => {
        item = item.toString()
        const nums = item.replace(/[\[\]]/g, '')

        if (nums.includes('-')) {
          const [start, end] = nums.split('-').map(Number)
          return [start, end]
        }

        if (nums.includes('+')) {
          return -1
        }

        return [Number(nums)]
      })
    },
    formatFreqRange (arr, type) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return this.$t('common.all')
      }

      const freqArr = arr

      const RANGE_MAP = type === 'session'
        ? FREQUENCY_SESSION_RANGE
        : FREQUENCY_PV_RANGE

      const DEFAULT_MAX = Math.max(...RANGE_MAP[1]) + 1

      const newNumber = freqArr.map(item => item === -1 ? DEFAULT_MAX : item)
      const min = Math.min(...newNumber)
      const max = Math.max(...newNumber)

      const ranges = Object.values(RANGE_MAP)
        .filter(value => {
          if (typeof value === 'number') {
            if (value === -1 && max === DEFAULT_MAX) {
              return value
            }
            return value >= min && value <= max
          }
          const [start, end] = value
          return start <= max && end >= min
        })
        .map(value => {
          if (typeof value === 'number') {
            if (value === -1) {
              return {
                start: type === 'session' ? 31 : 51,
                end: type === 'session' ? 31 : 51,
                text: type === 'session' ? `[${'31+'}]` : `[${'51+'}]`
              }
            }
            return { start: value, end: value, text: `[${value}]` }
          }
          const [start, end] = value
          return { start, end, text: `[${start}-${end}]` }
        })
        .sort((a, b) => a.start - b.start)

      return ranges.map(r => r.text).join(', ')
    },
    formatValues (arr) {
      return arr
        .map(v => v === '__null__'
          ? 'Inflow without utm_source parameter'
          : v
        )
        .join(', ')
    },
    setRegDate (utcDate) {
      const date = parse(utcDate, this.timezone)
      return format(date, 'YYYY-MM-DD HH:mm:ss')
    },
    onChangeCheckboxValue (value) {
      this.checkConfirm = value
    },
    getJamInfo () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum
      }
      getRemainJam(payload, true).then(res => {
        this.remainJam = res.paidCount + res.freeCount
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.isLoading = false
      })
      this.userJamInfo = {
        hasJam: 30,
        useJam: 3
      }
    },
    reportUseVoucher () {
      const requestData = {
        paymentType: this.useVoucher ? 'aiReportCredit' : this.selectedType.type,
        price: this.selectedType.type === 'jam' ? this.useJam : this.price,
        title: `${this.editableTitle}`,
        reportData: this.selectedMeta,
        lang: this.reportLang
      }
      this.$emit('checkDuplicate', this.reportLang, requestData)
    },
    requestPayment () {
      const requestData = {
        paymentType: this.useVoucher ? 'aiReportCredit' : this.selectedType.type,
        price: this.selectedType.type === 'jam' ? this.useJam : this.price,
        title: `${this.editableTitle}`,
        reportData: this.selectedMeta,
        lang: this.reportLang
      }
      this.$emit('payment', requestData)
      this.$emit('close')
      this.$emit('getSegment', this.selectedReport)
    },
    setReportInfo (options = null) {
      this.selectedReport = JSON.parse(JSON.stringify({ ...this.reportInfo, ...this.apiParamsData }))
      if (this.selectedReport.utm) {
        this.marketing.type = 'utm'
        this.marketing.data = this.selectedReport.utm
      } else {
        this.marketing = {}
      }
      this.showMarketing = false
    },
    checkMaxLength ({ target }) {
      this.errMessage = ''
      if (target && target.value.length === 0) return

      if (target.value.length > 70) {
        this.errMessage = this.$t('segmentReport.inputError.maxLength', { limit: 70 })
      } else {
        this.editableTitle = target.value
      }
    },
    nextAndDupCheck () {
      this.$emit('checkDuplicate', this.reportLang)
      this.currentStep = 2
    },
    setCurrentReport () {
      this.selectedReport = { ...this.reportInfo }
      this.setReportInfo()
      this.editableTitle = '[Scroll] 스크롤 데이터 분석 보고서'
      this.selectedMeta = null
      this.currentStep = 1
    },
    checkScroll () {
      this.$nextTick(() => {
        const scrollArea = this.$refs.scrollArea
        this.hasScroll = scrollArea.scrollHeight > scrollArea.clientHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// $cxReportColor: #ec0047;
$cxReportColor: #0074FF;
/deep/ .cx_color {
  color: $cxReportColor;
}
.brand-mark {
  color: $brandColor;
}
.ai-report-payment * {
  box-sizing: border-box;
}
.ai-report-payment {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  background-color: #fff;
  width: 530px;
  min-height: 400px;
  max-height: 622px;
  border-radius: 14px;
  font-weight: 400;
  color: #2f2f2f;
  box-sizing: border-box;
  padding: 30px 0 25px;
  display: flex;
  flex-direction: column;
  & > div {
    padding: 0 30px;
  }
  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .ai-payments-header {
    padding-bottom: 12px;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.2;
    //margin-bottom: 12px;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 12px;
        left: 0;
        top: 100%;
        z-index: 100;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);
      }

  }
  .ai-payments-contents {
    overflow-y: auto;
    color: #666;
    position: relative;
    padding: 24px 30px 5px 30px;
    .payments-segment-select-wrapper {
      padding-bottom: 15px;
    }
    .segment-stepper-wrapper {
      padding: 0 30px 30px;
      .payment-segment-stepper {
        width: 300px;
        margin: 5px auto 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .step-line {
          flex-grow: 1;
          border-top: 2px solid #d7d7d7;
        }
        .step-item {
          position: relative;
          .step-num {
            width: 28px;
            aspect-ratio: 1;

            border: 1px solid #999;
            border-radius: 50%;
            position: relative;
            color: #666;

            font-size: 14px;
            font-weight: 500;
            line-height: 1;
            text-align: center;
            padding: 6px;

            display: flex;
            align-items: center;
            justify-content: center;
          }
          .step-title {
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 130px;
            margin-top: 8px;
            text-align: center;
            color: #666;
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
          }
        }
        &.current-0 {
          .step-1 {
            .step-num {
              background-color: $cxReportColor;
              border-color: transparent;
              color: #fff;
            }
            .step-title {
              color: $cxReportColor;
            }
          }
        }
        &.current-1 {
          .step-1 {
            .step-num {
              background-color: #57AB00;
              border-color: transparent;
              color: #fff;
              padding: 5px;
            }
            .step-title {
              color: #478C00;
            }
          }
          .step-2 {
            .step-num {
              background-color: $cxReportColor;
              border-color: transparent;
              color: #fff;
            }
            .step-title {
              color: $cxReportColor;
            }
          }
        }
      }
    }
    .request-current-report-btn {
      padding-bottom: 32px;
      border-bottom: 1px solid #D7D7D7;
      margin-bottom: 30px;
      .current-report-btn {
        cursor: pointer;
        position: relative;
        padding: 12px 18px;
        width: 100%;
        color: #fff;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        line-height: 1;
        background: $cxReportColor;
        border-radius: 21px;
        i.icon {
          position: absolute;
          right: 13px;
          top: 50%;
          transform: translateY(-50%);
        }
        &:hover {
          background-color: darken($cxReportColor, 10);
          // background-color: #C6003C;
        }
      }
    }
    .report-suggest-list-wrapper {
      .report-suggest-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 14px;
        .suggest-title {
          color: #2F2F2F;
          font-size: 18px;
          font-weight: 500;
          line-height: 1;
          padding-bottom: 15px;
          position: relative;
          > span {
            color: $cxReportColor;
          }
          &:after {
            //content: url('../../assets/img/dashboard/red-line-ko.svg');
            width: fit-content;
            height: fit-content;
            position: absolute;
            left: -10px;
            top: 20px;
          }
          &:lang(en):after {
            //content: url('../../assets/img/dashboard/red-line-en.svg');
          }
          &:lang(ja):after {
            //content: url('../../assets/img/dashboard/red-line-ja.svg');
          }
        }
      }
      .report-suggest-description {
        color: #767676;
        font-size: 12px;
        padding-bottom: 17px;
        display: flex;
        justify-content: space-between;
        .description-part {
          line-height: 1.5;
          flex-grow: 1;
        }
        .guide-link-part {
          text-align: right;
          width: 50%;
          flex-shrink: 0;
          .segment-guide-link {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            color: #0074FF;
            font-size: 12px;
            i.icon {
              margin-left: 5px;
            }
          }
        }
      }
      .report-suggest-list {
        .report-suggest-item {
          cursor: pointer;
          padding: 15px 5px;
          color: #444;
          font-size: 13px;
          line-height: 1.5;

          display: flex;
          gap: 4px;
          span {
            display: inline-block;
            /deep/ mark {
              background-color: #E9EB68;
              font-weight: 700;
              padding: 0 3px;
            }
          }
          &:hover {
            color: #0074FF;
          }
        }
      }
    }
    .payments-select-wrapper {
      position: relative;

      .payment-type {
        cursor: pointer;
        padding: 18px 0 18px;
        font-size: 13px !important;
        &.disabled {
          pointer-events: none;
          opacity: .5;
        }
        .payment-title {
          font-size: 13px;
          line-height: 1.2;
          display: flex;
          align-items: center;
          gap: 10px;
          .check-selected {
            position: relative;
            display: inline-block;
            width: 14px;
            height: 14px;
            border: 2px solid #d4d4d4;
            border-radius: 50%;
            box-sizing: content-box;
            vertical-align: baseline;
          }
          .payment-opt {
            .payment-tag-sale {
              padding: 6px;
              border-radius: 6px;
              color: #2f2f2f;
              font-size: 12px;
              font-weight: 700;
              line-height: 1em;
              background-color: #FFB427;
            }
          }
        }
        .payment-body {
          transition: all .25s ease;
          transform-origin: top center;
          transform: scaleY(0);
          height: 0;
          overflow: hidden;
          padding: 0;
          .detail-info-wrapper {
            font-size: 13px;
            background-color: #F4F4F4;
            border-radius: 5px;
            border: 1px solid #D7D7D7;
            padding: 14px 30px;
            &.jam {
              & > .detail-info-item {
                display: flex;
                justify-content: space-between;
                font-size: 13px;
                font-weight: 500;
                padding: 14px 0;
                &.leftover-jam {
                  border-top: 1px dashed #D7D7D7;
                  .value, .error-msg {
                    color: $brandColor;
                  }
                  .error-msg {
                    font-size: 13px;
                    font-weight: 500;
                  }
                }
                &.use-jam {
                  margin-bottom: 10px;
                }
                &.has-jam {
                  .value {
                    color: #FC6A00;
                  }
                }
                .value {
                  font-size: 16px;
                }
              }
            }
            &.no-jam {
              background-color: #f5f5f5;
              border-radius: 4px;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 20px;
              .text {
                font-size: 13px;
                line-height: 1.5;
                font-weight: 500;
                color: #393939;
              }
              .changing-jam-btn {
                justify-content: center;
              }
            }
            &.ba-credit {
              background-color: #f5f5f5;
              border-radius: 4px;
              padding: 30px 20px;
              font-size: 16px;
              display: flex;
              justify-content: space-between;
              .title {
                font-weight: 500;
              }
              .price {
                font-weight: 700
              }
            }
          }
          .detail-description {
            color: #7f7f7f;
            font-size: 13px;
            margin: 10px 0 20px;
          }
          .changing-jam-btn {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
          }
        }
        &.selected {
          .payment-title {
            margin-bottom: 8px;
          }
          .payment-body {
            transform: scaleY(1);
            height: auto;
            padding: 8px 0;
          }
          .check-selected {
            border-color: $brandColor;
            &:before {
              content: '';
              position: absolute;
              width: 10px;
              height: 10px;
              background-color: $brandColor;
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .payment-report-wrapper {
        position: relative;
        &> div {
          margin-bottom: 12px;
        }
        .description {
          font-size: 12px;
          line-height: 1.2;
          margin: -13px 0 25px 0;
        }
        .report-name {
          display: flex;
          gap: 10px;
          align-items: center;
          .label {
            min-width: 100px;
            font-size: 13px;
            font-weight: 500;
            color: #767676;
          }
          .input-wrap {
            position: relative;
            flex-grow: 1;
            border-radius: 5px;
            border: 1px solid #bbb;
            background: #FFF;
            padding: 9px;
            display: flex;
            align-items: center;
            gap: 10px;
            .title-wrap {
              display: flex;
              align-items: center;
              width: calc(100% - 15px);

              .prefix {
                color: #2F2F2F;
                font-size: 14px;
                font-weight: 400;
                line-height: 1;
              }
            }
            .report-title {
              line-height: 1;
              &.indepth:after {
                content: '2.0';
                color: #0085FF;
                margin-left: 5px;
              }
            }
            input {
              width: 100%;
              border: 0;
              color: #2F2F2F;
              font-size: 14px;
              font-weight: 400;
              line-height: 1;
            }
            &.readonly {
              border: 0;
            }
            .input-error-pop {
              position: fixed;
              top: 15px;
              right: 43px;
              color: #444;
              background-color: #fff;
              padding: 16px;
              border-radius: 8px;
              font-size: 13px;
              line-height: 1.46;

              width: 200px;
              text-align: left;
              z-index: 2147483647;
              word-break: keep-all;
              word-wrap: break-word;
              box-sizing: border-box;
              box-shadow:
                0 8px 15px 0 rgba(0, 0, 0, 0.16),
                0 0 0 1px rgba(0, 0, 0, 0.16);
              &:after {
                content: '';
                position: absolute;
                background: inherit;
                width: 10px;
                height: 10px;
                top: 100%;
                right: 10px;
                transform: translate(-50%, -50%) rotate(-45deg);
                box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
              }
            }
            &:hover {
              border-color: #289EEF;
            }
            &.error {
              border-color: #E60724;
            }
          }
        }
        .report-segment-info {
          border-radius: 5px;
          border: 1px solid #D7D7D7;
          background: #F4F4F4;
          padding: 20px 20px 23px 20px;
          overflow-y: auto;

          .segment-badge {
            font-size: 16px;
            font-weight: 600;
            color: #2F2F2F;
            margin-bottom: 12px;
          }

          .segment-notice {
            margin-bottom: 16px;

            &__text {
              color: #EC0047;
              font-size: 13px;
              font-weight: 400;
              line-height: 1.6;
            }
          }

          .segment-detail-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            color: #2F2F2F;
            font-size: 14px;
            font-weight: 400;
            line-height: 150%;
            .segment-info-item {
              display: flex;
              .label-text {
                flex-shrink: 0;
                min-width: 80px;
                color: #666;
                width: 100px;
                &:lang(ja) {
                  font-size: .9em;
                }
                &.compare {
                  color: #EC0047;
                }
              }
              .value-text {
                color: #2f2f2f;
                flex-grow: 1;
                &.upper-first:first-letter {
                  text-transform: uppercase;
                }
                &.compare {
                  color: #EC0047;
                }
                .marketing-info-btn {
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  &.show {
                    & > i.icon {
                      transform: rotate(180deg);
                    }
                  }
                }
              }
              &.compare-period {
                > div {
                  color: #EC0047;
                }
              }
            }
          }
          .report-segment-notice {
            padding-top: 20px;
            font-size: 13px;
            line-height: 1.5;
          }
          &.mashup {
            .report-reg-date {
              color: #666;
              font-size: 13px;
              margin-bottom: 26px;
            }
            .report-title {
              color: #2F2F2F;
              font-weight: 500;
              font-size: 14px;
              .inDepth-mark {
                color: #0085FF;
              }
            }
          }
        }
        .payment-options-list {
          .select-payment-option {
            display: flex;
            align-items: center;
            margin: 24px 0 0 0;
            padding: 0 10px;
            font-size: 13px;
            border-bottom: 1px dashed #d4d4d4;
            gap: 10px;
            .title-label {
              min-width: 100px;
              color: #777;
              font-size: 13px;
              font-style: normal;
              font-weight: 500;
              line-height: 120%
            }

            .icon--flag {
              width: 24px;
              height: 24px;
              flex-shrink: 0;
              border-radius: 50em;
              background-size: 22px 22px;
              border: 1px solid #D7D7D7;;
            }
            .select-option-wrapper {
              display: flex;
              gap: 24px;
              .payment-type {
                padding: 0;
                border: 0;
                .payment-title {
                  margin: 0;
                }
                & .lang {
                  display: flex;
                  width: 44px;
                  height: 20px;
                  padding: 4px 2px;
                  justify-content: center;
                  align-items: center;
                  gap: 5px;
                  flex-shrink: 0;
                  border-radius: 4px;
                  box-sizing: border-box;
                  background: #FFF;

                  & .lang-text {
                    text-transform: uppercase;
                    color:  #2F2F2F;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 100%;
                  }
                }
              }
            }
            .selected-voucher-msg {
              margin-top: -8px;
              padding-bottom: 21px;
            }
          }
          &:not(.show-notice) {
            .select-payment-option {
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
      }
      .payments-method-wrapper {
        margin-top: -18px;
      }
    }
    .ai-payments-notice {
      border-top: 1px dashed  #D7D7D7;
      padding-left: 20px;

      .notice-list {
        color: #666;
        font-size: 13px;
        list-style-type: disc;
        margin: 20px 0;
        .notice-item {
          margin-bottom: 8px;
          font-size: 13px;
          line-height: normal;
          letter-spacing: -.5px;
          &:lang(ja) {
            font-size: 1em;
          }
        }
      }
    }
  }
  .ai-payments-footer {
    position: relative;
      &.has-scroll {
        .divide-line {
          border: none;
        }
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 12px;
          left: 0;
          bottom: 100%;
          z-index: 100;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.06) 100%);
        }
      }
    .ai-payments-check-confirm {
      min-height: 44px;
      padding: 12px 0 28px;
      text-align: center;
      & /deep/ .ui_checkbox {
        margin-left: 0;
        .text {
          font-size: 13px;
        }
      }
    }
    .payment-button-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      padding-top: 24px;
      font-size: 13px;

      .icon--inflow__back, .icon--arrow-right-red {
        width: 14px;
        height: 14px;
        background-size: contain;
      }

      .go-back {
        cursor: pointer;
        position: absolute;
        left: 0;
        bottom: 0;
        color: #444;
        padding: 12px 0;
        font-size: 13px;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
        gap: 5px;
        border-radius: 5px;
      }
    }
  }
}
.ui-btn + .ui-btn {
  margin-left: 5px;
}
.value-text {
  color: #444;
  .contents {
    padding: 12px 0;
    .marketing-data-list {
      color: #666;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.5;
      .marketing-data-item {
        display: flex;
        gap: 8px;
        font-size: 12px;
        span.label {
          flex-shrink: 0;
          width: 61px;
        }
        span.value {
          flex-grow: 1;
        }
        span.inflow {
          display: inline-block;
        }
      }
    }
    .marketing-data-tree {
      position: relative;
      color: #666;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.5;
      padding: 5px 0;
      &.step-1 {
        margin-left: 15px;
      }
      &.step-2 {
        margin-left: 25px;
      }
      &.step-1:before, &.step-2:before, &.checkbox > div:before {
        content: '';
        position: absolute;
        top: 12px;
        left: -15px;
        width: 6px;
        height: 6px;
        border: 1px solid #979797;
        border-radius: 2px;
        border-top-width: 0;
        border-right-width: 0;
      }
      &.checkbox > div, &.range {
        position: relative;
        padding: 5px 0;
        &:before {
          transform: rotate(-135deg) translate(3px);
        }
      }
      &.answer {
        margin-left: 18px;
        gap: 10px;
      }
      &.range {
        display: flex;
        gap: 5px;

        &> div {
          width: 25px;
          height: 25px;
          text-align: center;
          padding: 5px;
          line-height: 1;
          border-radius: 4px;
          border: 1px solid #979797;
        }

      }
    }
  }
}

</style>
